import { Add } from '@carbon/icons-react';
import { Box } from '@mui/material';
import Fab from '@mui/material/Fab';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

import * as Preact from 'preact';

export interface Props {
    configuratorType: string;
    optionType?: string;
}

export const Component = (p: Props) => {
    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '64px' }}>
            <Typography variant="h4">{`Loading ${p.configuratorType} configurator...`}</Typography>
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <LinearProgress />
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                    }}
                >
                    <Typography variant="subtitle1" color="text.secondary">
                        Clicking
                    </Typography>
                    {/* TODO: replace with image of actual button */}
                    <Fab
                        size="small"
                        sx={{
                            width: '19px',
                            height: '19px',
                            minHeight: '19px',
                            '&:disabled': {
                                backgroundColor: '#F5F5F5',
                                color: '#000000',
                                filter: 'drop-shadow(0px 1px 18px rgba(0,0,0,0.95))',
                            },
                        }}
                        disabled
                    >
                        <Add size={9} />
                    </Fab>
                    <Typography
                        variant="subtitle1"
                        color="text.secondary"
                    >{`will add a new ${p.optionType}`}</Typography>
                </Box>
            </Box>
        </Box>
    );
};

Component.displayName = 'LoadingText';
